import { useFieldBase, } from './useField';
export function useDatepickerField(props) {
    // get base props of validation fields
    const [{ value, ...baseProps }, saveState] = useFieldBase(props);
    return {
        ...baseProps,
        onChange: (value) => saveState(value ?? undefined),
        TextFieldProps: {
            onBlur: () => !value && saveState(''),
        },
        value: value ?? null, // FIXME: do we need ?? null here?
    };
}
// TODO: for backwards compatibility, can be removed once all hooks are renamed
export const useValidationDatepickerField = useDatepickerField;
